import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivityCreateOrMergeContactFromExternalAttendee as ActivityCreateOrMergeContactFromExternalAttendeeMutation,
    ActivityCreateOrMergeContactFromExternalAttendeeVariables,
    ActivityCreateOrMergeContactFromExternalAttendeeInput,
} from 'nutshell-graphql-types';

import ACTIVITY_CREATE_OR_MERGE_CONTACT_FROM_EXTERNAL_ATTENDEE from '../mutations/create-or-merge-contact-from-external-attendee.graphql';

export const useActivityCreateOrMergeContactFromExternalAttendee = (): {
    activityCreateOrMergeContactFromExternalAttendee: (
        arg1: ActivityCreateOrMergeContactFromExternalAttendeeInput
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [activityCreateOrMergeContactFromExternalAttendee, {loading, error}] = useMutation<
        ActivityCreateOrMergeContactFromExternalAttendeeMutation,
        ActivityCreateOrMergeContactFromExternalAttendeeVariables
    >(ACTIVITY_CREATE_OR_MERGE_CONTACT_FROM_EXTERNAL_ATTENDEE);

    return {
        activityCreateOrMergeContactFromExternalAttendee: (
            input: ActivityCreateOrMergeContactFromExternalAttendeeInput
        ) => activityCreateOrMergeContactFromExternalAttendee({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
